export const jobs1 = [
  {
    // icon: 'https://img.alicdn.com/tfs/TB1Cf5wJmrqK1RjSZK9XXXyypXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1xnvIF.H1gK0jSZSyXXXtlpXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB1FtvMFUT1gK0jSZFhXXaAtVXa-204-204.png',
    name: '项目经理',
    color: '8083b4',
    description: [
      {
        title: '职位描述',
        content: [
          '1、负责程序调试、项目实施工作；',
          '2、负责项目整体协调、进度跟踪等监管工作；',
          '3、充分了解客户需求，建立良好的客户关系；',
          '4、能理解客户需求，推广公司相应产品；',
          '5、参与医疗信息化产品的路标规划,调研客户需求，沟通用户需求；',
          '6、跟踪上线产品的市场效果、用户反馈，收集和主动挖掘改进需求，根据业务需要持续改进产品，提升用户体验。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、具有医疗行业5年以上的行业经验；',
          '2、从事过三甲医院整体项目的实施、维护或相关开发人员；或从事过区卫产品的实施、维护或相关开发人员；',
          '3、有医疗行业数据处理、分析经验人员优先考虑；',
          '4、具有一定的逻辑思维能力和数据敏感性。',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1qi56JhnaK1RjSZFtXXbC2VXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1YgYNFYj1gK0jSZFOXXc7GpXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB1ssbPFNv1gK0jSZFFXXb0sXXa-204-204.png',
    name: 'BI项目经理(医疗行业)',
    color: '8fc4ab',
    description: [
      {
        title: '职位描述',
        content: [
          '1、能独立担任BI项目实施的项目经理，对于BI项目整体过程和重点有清晰的把握；',
          '2、根据用户需求完成BI报表口径确认、核对及交付；',
          '3. 负责项目管理、风险控制。在项目实施环节，负责资源调配、项目进度跟踪管理、项目风险控制；',
          '4. 与项目组、其它相关部门及合作伙伴密切合作，与客户保持良好的关系和有效的沟通。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、BI相关岗位3年以上工作经验； 作为项目经理，至少实施过两个完整的BI项目；',
          '2、熟悉数据仓库模型，具备数据仓库开发实际经验；',
          '3、熟练掌握一种BI产品，包括但不限于帆软/Tableau/Qlikview/OBIEE/Cognos/BO/Quicksight/MSTR等；',
          '4、熟练掌握SQL语言，熟悉一种数据库，如Oracle/SqlServer/MySql等；',
          '5、具有医疗行业BI开发经验优先考虑。',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1bvSAJbPpK1RjSZFFXXa5PpXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB18h_LF5_1gK0jSZFqXXcpaXXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB1N2_PFQT2gK0jSZPcXXcKkpXa-204-204.png',
    name: '互联网医疗产品经理',
    color: '3488c9',
    description: [
      {
        title: '职位描述',
        content: [
          '1.理解和挖掘大众对健康信息和医疗服务的需求，抽象产品的使用场景进行产品规划和设计；',
          '2.负责通过数据分析、用户研究不断挖掘用户需求，输出解决方案，搭建和完善产品体系；',
          '3.流程化开发运营管理，确保开发流程高效运转；',
          '4.跨部门工作的协调与沟通、支持配合。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1.5年及以上产品经验，有互联网产品设计经验，医疗行业背景经验者优先；',
          '2.积极思考，不拘泥于现有产品形式，有创新的思维，对移动端产品有敏锐的触觉；',
          '3.拥有较强的执行力，自我驱动，责任心强，以结果为导向；',
          '4.对于行业主流医疗产品有过深入研究，具有良好的互联网思维。',
        ],
      },
    ],
  },
];
export const jobs2 = [
  {
    // icon: 'https://img.alicdn.com/tfs/TB1oMiGJbrpK1RjSZTEXXcWAVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1mo_MFYH1gK0jSZFwXXc7aXXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB1jhzOFQL0gK0jSZFxXXXWHVXa-204-204.png',
    name: '数据产品经理(医疗方向)',
    color: 'f9cb4b',
    description: [
      {
        title: '职位描述',
        content: [
          '1、研究医疗行业需求、行业变化和竞争形势，探索大数据及数据应用在医疗行业的不同使用场景与切入点，形成市场需求分析文档；',
          '2、围绕医疗大数据整合、数据处理、分析、预测、应用，就政府监管、医院运营管理等方便开展技术 研发与应用创新；',
          '3、关注医疗大数据应用相关方向的前沿研究，并将相关成果快速产品化、商业化；',
          '4、完成相关产品的竞品分析、需求调研、产品设计、产品推广及落地；',
          '5、与开发、测试、运营等多个部门进行充分沟通协调，保证版本功能的高效迭代，达到产品目标；',
          '6、持续监控和分析产品上线后的用户反馈和使用数据，并进行分析归纳，不断改善用户体验；',
          '7、负责运营后台的规划和功能设计，提供各种工具提升运营效率。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、热爱健康医疗行业, 热爱产品, 对待产品视如己出；',
          '2、三年以上项目经理/产品经理/数据中台相关工作经验，HIS、区域平台相关从业背景者优先；',
          '3、熟悉医院管理、临床诊疗流程、放射影像学、卫计委区域医疗、公共卫生管理及服务等业务领域者优先，熟悉医学信息学领域相关标准者优先；',
          '4、有较强的产品意识和逻辑思考能力，有数据挖掘分析经验，具备敏锐的数据洞察力，熟悉医疗数据建模分析者优先；',
          '5、具有高度的工作责任心，良好的协调、沟通能力和团队合作精神。',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1cyiHJkvoK1RjSZFNXXcxMVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1gC_JFYr1gK0jSZFDXXb9yVXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB1Nxo1a5cKOu4jSZKbXXc19XXa-204-204.png',
    name: '售前工程师(医疗行业)',
    color: 'F27954',
    description: [
      {
        title: '职位描述',
        content: [
          '1、负责或支持公司全国各项目的售前咨询工作，组织协调资源，对口跟进具体商机；',
          '2、 负责或支持商机相关的需求调研、总体规划、项目建议书、可行性研究报告、各类建设方案编制以及各类用户现场汇报工作；',
          '3、 负责或支持公司产品&解决方案梳理工作；',
          '4、 负责或支持创新业务的解决方案梳理工作；',
          '5、 负责或支持样板用户梳理、宣传资料制作等工作；',
          '6、 支持项目招投标工作；',
          '7、 完成售前咨询相关的其它任务。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、信息系统、计算机或公共卫生相关专业优先；',
          '2、 具有良好的表达说服力及沟通能力；',
          '3、 具有优秀的文字表达能力和良好的逻辑分析能力；',
          '4、 具有良好的团队合作精神，善于团队协作；',
          '5、 具有职业化的自我管理能力和强烈的责任心；',
          '6、 熟练掌握日常办公工具Word、Excel和PPT；',
          '7、 具有医疗卫生行业经验优先；',
          '8、 掌握医疗机构相关业务流程、管理模式、相关的医疗知识和医疗信息化标准。',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1_WKyJgDqK1RjSZSyXXaxEVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1mpTMF7L0gK0jSZFxXXXWHVXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB12i2PFHY1gK0jSZTEXXXDQVXa-204-204.png',
    name: '互联网医疗平台运营',
    color: 'eb4446',
    description: [
      {
        title: '职位描述',
        content: [
          '1.理解和挖掘大众对健康信息和医疗服务的需求，抽象用户场景进行用户引导和推动；',
          '2.负责互联网医院平台的运营，扩大平台影响力，培养用户心智；',
          '3.对互联网诊疗模式有一定的见解，基于互联网诊疗闭环有完整的运营思路并落地执行；',
          '4.能够独立承担跨部门工作的协调与沟通。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1.2年及以上运营经验，有互联网产品运营经验，医疗行业背景经验者优先；',
          '2.积极思考，有创新思维和互联网思维；',
          '3.拥有较强的执行力，自我驱动，责任心强，以结果为导向。',
        ],
      },
    ],
  },
];

export const jobs3 = [
  {
    // icon: 'https://img.alicdn.com/tfs/TB1oMiGJbrpK1RjSZTEXXcWAVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1mWrKF9f2gK0jSZFPXXXsopXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB1XM6KFLb2gK0jSZK9XXaEgFXa-204-204.png',
    name: '前端开发工程师',
    color: 'f9cb4b',
    description: [
      {
        title: '职位描述',
        content: [
          '在这里， 你将有机会与交互设计师一起，美化产品线Web功能的设计；',
          '有机会与视觉设计师一起，完成产品线Web功能的开发与实现；',
          '有机会做全栈式开发；',
          '有机会做移动端开发；',
          '有机会做性能、架构等方面的改进与优化；',
          '有机会自己亲手打造一个产品的从设计到发布；',
          '你还将加入到我们业内最前沿Web技术的研究与开发中。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '我们希望你，可以熟练使用各种Web前端技术，包括HTML(5)/CSS(3)/Javascript等，并有相关的项目开发经验或成果；',
          '我们希望你，熟悉前端工程化，用过git，gulp或webpack等工具，最好有自己的github仓库；',
          '我们希望你，有基于Ajax应用的开发经验，有React/Vue，NodeJS开发经验，有移动端/小程序开发经验；',
          '我们希望你，深刻理解Web标准，对可用性、可访问性等相关知识有实际的了解；',
          '我们希望你，对算法、数据结构、建模有一定了解；',
          '我们希望你，关注新事物、新技术，有较强的学习能力，喜欢挑战，并且个性乐观开朗，逻辑性强，善于和各种背景的人合作。',
          '快到碗里来~',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1cyiHJkvoK1RjSZFNXXcxMVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1iVrOF4D1gK0jSZFyXXciOVXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB13HjRFQT2gK0jSZFkXXcIQFXa-204-204.png',
    name: 'JAVA工程师',
    color: 'F27954',
    description: [
      {
        title: '职位描述',
        content: [
          '深入理解业务需求，进行相关系统的设计和开发；',
          '持续优化系统架构和系统的可扩展性，参与系统的长期设计规划；',
          '持续优化系统性能，保障系统的高可用性。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、Java基础扎实，具备三年以上的Java研发经验，熟悉通信、多线程、高并发处理、内存管理等技术。对JVM原理有一定的了解。对于用过的开源框架，能了解到它的原理和机制；对Spring,ibatis,struts等开源框架熟悉；',
          '2、熟悉分布式系统的设计和应用，熟悉分布式框架、中间件、数据库等机制，能对分布式常用技术进行合理应用解a决问题；',
          '3、掌握多线程及高性能的设计与编码及性能调优；有高并发应用开发经验优先；',
          '4、掌握Microservice、FaaS、Serverless等微服务或无服务架构及实践经验者优先；',
          '5、对云计算或云计算产品有认知有实践经验者优先；',
          '6、具有良好的沟通技能，团队合作能力，追求极致的心态；',
          '7、有较强团队协作精神、学习能力和责任感，为达成团队目的，能主动承担团队所需完成的其他工作，比如开发环境的维护、测试等。',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1_WKyJgDqK1RjSZSyXXaxEVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1YJHLF7Y2gK0jSZFgXXc5OFXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB1ie_RFG61gK0jSZFlXXXDKFXa-204-204.png',
    name: '测试专家',
    color: 'eb4446',
    description: [
      {
        title: '职位要求',
        content: [
          '1. 熟悉Java编程语言，有Shell或其它脚本语言等使用经验者优先；',
          '2. 至少3年以上软件测试开发工作经验；',
          '3. 有性能、安全、白盒测试等专业测试领域经验者优先；',
          '4. 具备互联网医疗、搜索、大数据处理、分布式系统、数据库和网络等业务领域测试经验者优先；',
          '5. 精通测试流程和测试用例设计方法,能主动进行技术钻研；',
          '6. 解决复杂问题和编写自动测试工具、设计质量平台和系统的能力。',
        ],
      },
    ],
  },
];

export const jobs4 = [
  {
    // icon: 'https://img.alicdn.com/tfs/TB1oMiGJbrpK1RjSZTEXXcWAVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1CpLNF1L2gK0jSZFmXXc7iXXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB1bw2SFHj1gK0jSZFuXXcrHpXa-204-204.png',
    name: '算法工程师',
    color: 'f9cb4b',
    description: [
      {
        title: '职位描述',
        content: [
          '参与医疗大数据的分析、处理、统计、挖掘，开发基于医疗大数据的疾病画像、风险预测、知识图谱建立等算法及产品。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1. 必须：计算机及统计相关专业，硕士以上学历或者重点大学本科1年以上相关工作经验；',
          '2. 必须：具备扎实的算法、数据结构、程序设计基础知识， 掌握这里列出领域的基本原理和基础知识：面向对象的程序设计、多线程模型、分布式架构；',
          '3. 必须： 熟悉常见的机器学习算法(Bayes, 决策树、SVM、NN、LSTM等), 有扎实的数学基础；',
          '4. 加分项：',
          '（a）使用sklearn/keras/tensorflow经验；',
          '（b）git使用经验；',
          '（c）有自然语言处理经验；',
          '（d）有医疗数据处理经验；',
          '（e）有实体识别、实体链接、知识图谱建立等经验；',
          '（f）有hadoop或者odps等大数据平台数据处理经验。',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1cyiHJkvoK1RjSZFNXXcxMVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1BMTKF7L0gK0jSZFAXXcA9pXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB1gwYRFG61gK0jSZFlXXXDKFXa-204-204.png',
    name: '大数据开发工程师',
    color: 'F27954',
    description: [
      {
        title: '职位描述',
        content: [
          '1、负责公司数据平台项目的ETL设计、实现以及优化；',
          '2、负责ETL流程优化，关键问题解决；',
          '3、研究医院信息化数据，负责数据建模、数据存储设计；',
          '4、使用ETL技术对医院信息系统数据进行提取、清洗、转换和整合；',
          '5、负责基于Hadoop/Spark生态的大数据离线/实时处理平台开发；',
          '6、负责基于阿里云的maxcompute的大数据离线处理平台开发；',
          '7、负责数据源调研、入库、开发的全流程工作，并保证数据质量。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、有2年以上医疗行业数据建模经验；了解数据建模方法论，并且在项目中实践甚至优化扩展；有大型项目建模经验优先；对数据模型有独到理解；',
          '2、熟悉大数据平台，了解Hadoop、Hive、Hbase，有大型数据中心运维经验或实施经验者优先；',
          '3、2年以上医院业务信息化实施开发经历优先 ；有His、Emr开发经验优先；',
          '4、有数据仓库ETL经验，对调度、元数据、数据质量等有一定理解；',
          '5、有良好的逻辑思维能力，主动思考，善于学习，与团队沟通无障碍；',
          '6、熟悉java,python,shell,scala等任一种开发语言；',
          '7、拥有良好的沟通、表达能力，工作认真负责，学习能力强，执行力强，乐于接受挑战并具备较好的承压能力。',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1_WKyJgDqK1RjSZSyXXaxEVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1Ce_IF.z1gK0jSZLeXXb9kVXa-204-204.png',
    micon: 'https://img.alicdn.com/tfs/TB1PwnMFQP2gK0jSZPxXXacQpXa-204-204.png',
    name: 'ETL开发工程师',
    color: 'eb4446',
    description: [
      {
        title: '职位描述',
        content: [
          '1、 负责医院信息系统源数据分析工作；',
          '2、 使用ETL工具对医院信息系统数据进行提取、清洗、转换和整合；',
          '3、 进行数据任务流程调优及准确性改进，进行数据质量监测、校验和提升；',
          '4、 完成技术经理安排的其他工作。',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、有医疗信息系统（HIS、EMR、集成平台等）开发及实施经验优先；',
          '2、熟练掌握Oracle、SQL Server、MySQL、PostgreSQL等至少一种主流数据库的使用；',
          '3、熟练掌握SSIS、Kettle、Informatica等至少一种ETL工具的使用；',
          '4、熟练掌握T-SQL，PL/SQL，具备编写、优化复杂SQL的能力；',
          '5、良好的沟通能力、学习思考、解决问题能力，良好的抗压和适应能力；',
          '6、能适应一定频率出差或项目驻场开发者优先；',
          '7、有ETL开发或数据集成经验者优先。',
        ],
      },
    ],
  },
];

export const aboutData = {
  title: '关于我们',
  subtitle: 'about us',
  extra: {
    title: '查看全部',
    path: '/about',
  },
  path: '/about',
  slogan: '数据让健康触手可及',
  jobs1,
  jobs2,
  jobs3,
  jobs4,
  map: 'https://img.alicdn.com/tfs/TB1UVDFqX67gK0jSZPfXXahhFXa-874-578.jpg',
  info: {
    tel: '4008558517',
    email: 'ping.chaip@alibaba-inc.com',
    address: '浙江省杭州市余杭区文一西路和绿汀路交叉口浙富西溪堂1号楼',
  },
};
